<script setup lang="js">
import { computed } from 'vue'
import ActionMenuButton from '../src/ActionMenuButtonMenu.vue'
import { extActionButtonMenuProps } from '../src/props'

// Props from our ActionMenuButton system (editor, extension, t)
const props = defineProps(extActionButtonMenuProps())

// Build dropdown items from the extension's configured alignments
const items = computed(() => {
  const alignments = (props.extension && props.extension.options && props.extension.options.alignments)
    ? props.extension.options.alignments
    : ['left', 'center', 'right', 'justify']

  const imageDisplayForAlign = (align) => {
    if (align === 'left') return 'left'
    if (align === 'center') return 'block'
    if (align === 'right') return 'right'
    return 'inline'
  }

  return alignments.map((k) => ({
    title: props.t(`editor.textalign.${k}.tooltip`),
    icon: k,
    isActive: () => {
      if (props.editor.isActive('image')) {
        return props.editor.isActive('image', { display: imageDisplayForAlign(k) }) || false
      }
      return props.editor.isActive('paragraph', { textAlign: k }) || false
    },
    action: () => {
      const chain = props.editor.chain().focus()
      if (props.editor.isActive('image') && chain.updateImage) {
        chain.updateImage({ display: imageDisplayForAlign(k) }).run()
        return
      }
      if (chain.setTextAlign) chain.setTextAlign(k).run()
    },
    disabled: props.editor.isActive('image')
      ? false
      : !(props.editor?.can?.().setTextAlign ? props.editor.can().setTextAlign(k) : false),
  }))
})
</script>

<template>
  <ActionMenuButton
    :editor="editor"
    :items="items"
    :max-height="280"
    :disabled="items.filter(k => k.disabled).length === items.length"
    :tooltip="t('editor.textalign.tooltip')"
    icon="center"
  />
</template>
